import React, { useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, getBaseDir, float2moeda, userHasRole } from '../../../utils.js';
import ReportFilter from '../../../components/report/ReportFilter.js';
import TableBuilder from '../../../table_builder.js';
const XLSX = require('xlsx');

const SalesPerDoctorReport = () => {
    const exportToExcel = () => {
        const wb = XLSX.utils.book_new();
        let allData = [];
        
        // Pegar o container específico e suas tabelas
        const container = document.querySelector('.js-sales-per-doctor-content');
        container.querySelectorAll('h2').forEach((doctorHeader) => {
            const doctorName = doctorHeader.textContent;
            const tableDiv = doctorHeader.nextElementSibling; // div.table-responsive
            const table = tableDiv.querySelector('table');
            
            // Adicionar uma linha com o nome do doutor
            allData.push(['Doutor:', doctorName]);
            allData.push(['Cliente', 'Venda', 'Data', 'Valor']);
            
            // Pegar dados da tabela
            const rows = table.querySelectorAll('tbody tr');
            rows.forEach((row) => {
                const cells = row.querySelectorAll('td');
                allData.push([
                    cells[0].textContent, // Cliente
                    cells[1].textContent, // Venda
                    cells[2].textContent, // Data
                    cells[3].textContent  // Valor
                ]);
            });
            
            // Adicionar o total do doutor
            const footerRow = table.querySelector('tfoot tr');
            allData.push([
                'Total', '', '',
                footerRow.querySelector('td:last-child').textContent
            ]);
            
            // Adicionar linha em branco para separação
            allData.push(['']);
        });
        
        // Atualizar o seletor do total geral também
        const totalGeral = container.querySelector('.js-total-general-sales').textContent.trim();

        allData.push(['Total Geral', '', '', totalGeral]);
        
        // Criar worksheet e adicionar ao workbook
        const ws = XLSX.utils.aoa_to_sheet(allData);
        
        // Ajustar larguras das colunas
        const colWidths = [30, 15, 15, 15];
        ws['!cols'] = colWidths.map(w => ({ wch: w }));
        
        // Adicionar a worksheet ao workbook
        XLSX.utils.book_append_sheet(wb, ws, "Vendas por Doutor");
        
        // Adicionar data de geração
        XLSX.utils.sheet_add_aoa(ws, [["Emitido em " + moment().format('DD/MM/YYYY HH:mm:ss')]], {origin: -1});
        
        // Exportar o arquivo
        XLSX.writeFile(wb, `relatorio_vendas_por_doutor_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`);
    };

    const exportJsPdf = () => {
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF('p', 'mm', 'a4');
        
        // Configurações iniciais
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 10;
        let yPos = margin;
        
        // Base64 encoded image string (you can convert your image to Base64)
        const imgData = 'data:image/png;base64,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'; // Replace this with your Base64 image string
        doc.addImage(imgData, 'PNG', margin, yPos, 25, 10);
        yPos += 15;
        
        doc.setFontSize(16);
        doc.text('Relatório de Vendas por Doutor', pageWidth/2, yPos, { align: 'center' });
        yPos += 10;
        
        doc.setFontSize(12);
        doc.text(`Relatório gerado em ${moment().format('DD/MM/YYYY HH:mm:ss')}`, pageWidth/2, yPos, { align: 'center' });
        yPos += 10;

        doc.setFontSize(14);
        doc.text(`Período: ${moment(window.startDate).format('DD/MM/YYYY')} a ${moment(window.endDate).format('DD/MM/YYYY')}`, margin, yPos);
        yPos += 10;
        
        // Pegar o container específico e suas tabelas
        const container = document.querySelector('.js-sales-per-doctor-content');
        container.querySelectorAll('h2').forEach((doctorHeader) => {
            // Verificar se precisa de nova página
            if (yPos > 250) {
                doc.addPage();
                yPos = margin;
            }
            
            const doctorName = doctorHeader.textContent.trim();
            const tableDiv = doctorHeader.nextElementSibling;
            const table = tableDiv.querySelector('table');
            
            // Nome do doutor
            doc.setFontSize(14);
            doc.text(doctorName, margin, yPos);
            yPos += 7;
            
            // Tabela de vendas
            doc.autoTable({
                html: table,
                startY: yPos,
                margin: { left: margin },
                styles: { fontSize: 9 },
                headStyles: { 
                    fillColor: [200, 0, 0],
                    textColor: [255, 255, 255]
                },
                footStyles: { 
                    fillColor: [240, 240, 240],
                    textColor: [0, 0, 0],
                    fontStyle: 'bold'
                },
                didDrawPage: (data) => {
                    yPos = data.cursor.y + 10;
                }
            });
        });
        
        // Atualizar o seletor do total geral também
        const totalGeral = container.querySelector('.row .col-12 h3').textContent.trim();
        
        // Verificar se precisa de nova página para o total geral
        if (yPos > 270) {
            doc.addPage();
            yPos = margin;
        }
        
        // Adicionar uma linha separadora antes do total geral
        doc.setDrawColor(200, 200, 200);
        doc.line(margin, yPos - 5, pageWidth - margin, yPos - 5);
        
        // Adicionar o total geral com destaque
        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        doc.text(totalGeral, margin, yPos);
        
        doc.save(`relatorio_vendas_por_doutor_${moment().format('YYYY-MM-DD_HH-mm')}.pdf`);
    };

    window.exportToExcel = exportToExcel;
    window.exportJsPdf = exportJsPdf;

    return (
        <>test</>
    );
}

try {
    if (document.getElementById('js-sales-per-doctor-root')) {
      const container = document.getElementById('js-sales-per-doctor-root');
      const root = createRoot(container); // createRoot(container!) if you use TypeScript
      root.render(<SalesPerDoctorReport />);
    }
  } catch(err) {
    console.error('SalesPerDoctorReport error', err);
  }